import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import BookingPage from "./pages/BookingPage";
import QuotePage from "./pages/QuotePage";
import TrackingPage from "./pages/TrackingPage";
import ShopPage from "./pages/ShopPage";
import SubscriptionsPage from "./pages/LavagePage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import RegisterCompanyPage from "./pages/RegisterCompanyPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AccountPage from "./pages/AccountPage";
import AdminDashboard from "./pages/AdminDashboard";
import ComptabilitePage from "./pages/ComptabilitePage";
import PaymentResultPage from "./pages/PaymentResultPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import LoyaltyPage from "./pages/LoyaltyPage";
import PromotionsPage from "./pages/PromotionsPage";
import LocationPage from "./pages/LocationPage";
import AnnoncesPage from "./pages/AnnoncesPage";
import MobilitePage from "./pages/MobilitePage";
import ReservationMobilitePage from "./pages/ReservationMobilitePage";
import CheckoutPage from "./pages/CheckoutPage";
import SubscriptionCheckoutPage from "./pages/SubscriptionCheckoutPage";
import CartSidebar from "./components/CartSidebar";
import WashBookingPage from "./pages/WashBookingPage";
import WashConfirmationPage from "./pages/WashConfirmationPage";
import TowingPage from "./pages/TowingPage";
import TowingConfirmationPage from "./pages/TowingConfirmationPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#18181B',
                color: '#FAFAFA',
                border: '1px solid #27272A'
              }
            }}
          />
          <CartSidebar />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="reservation" element={<BookingPage />} />
              <Route path="devis" element={<QuotePage />} />
              <Route path="suivi" element={<TrackingPage />} />
              <Route path="boutique" element={<ShopPage />} />
              <Route path="tarifs-lavage" element={<SubscriptionsPage />} />
              <Route path="reservation-lavage" element={<WashBookingPage />} />
              <Route path="lavage/confirmation" element={<WashConfirmationPage />} />
              <Route path="depannage" element={<TowingPage />} />
              <Route path="depannage/confirmation" element={<TowingConfirmationPage />} />
              <Route path="fidelite" element={<LoyaltyPage />} />
              <Route path="promotions" element={<PromotionsPage />} />
              <Route path="location" element={<LocationPage />} />
              <Route path="annonces" element={<AnnoncesPage />} />
              <Route path="mobilite" element={<MobilitePage />} />
              <Route path="reservation-mobilite" element={<ReservationMobilitePage />} />
              <Route path="checkout" element={<CheckoutPage />} />
              <Route path="paiement-abonnement" element={<SubscriptionCheckoutPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="connexion" element={<LoginPage />} />
              <Route path="inscription" element={<RegisterPage />} />
              <Route path="inscription-societe" element={<RegisterCompanyPage />} />
              <Route path="mot-de-passe-oublie" element={<ForgotPasswordPage />} />
              <Route path="reinitialiser-mot-de-passe" element={<ResetPasswordPage />} />
              <Route path="mon-compte" element={<AccountPage />} />
              <Route path="admin" element={<AdminDashboard />} />
              <Route path="comptabilite" element={<ComptabilitePage />} />
              <Route path="payment-result" element={<PaymentResultPage />} />
              <Route path="payment/success" element={<PaymentSuccess />} />
              <Route path="payment/cancel" element={<PaymentCancel />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
